import Vue from 'vue';
import IscSvgIcon from '@isyscore/icons';

Vue.use(IscSvgIcon);
